import React, { useContext } from "react";

import { Preview } from "@creatomate/preview";

import { ElementSource } from "chq";
import { useProfile } from "app/context";

import { Icon, PlainButton } from "@culturehq/components";
import { CreatomateContext } from "../../contexts/VideoStudioContext";
import { isSubtitleText, loadNewSubtitle, syncSubtitles } from "../../sidebar/tabs/subtitle/utils";
import { VIDEO_TYPE } from "../../utils/constants";

interface UndoButtonProps {
  preview: Preview;
}

const UndoButton: React.FC<UndoButtonProps> = ({
  preview
}) => {
  const { data, handleUpdateData } = useContext(CreatomateContext);
  const { mediaVersionHistory, originalReplacedVideo, subtitles } = data;
  const { profile: { organization } } = useProfile();
  const isTheOriginal = mediaVersionHistory?.length === 0;

  const recoverSubtitles = async (creatomateJson: Record<string, any>) => {
    const filteredElements = creatomateJson.elements.filter(
      (element: ElementSource) => !isSubtitleText(element.name)
    );
    await preview.setSource({ ...creatomateJson, elements: filteredElements }, false);
    handleUpdateData({ blockSubtitles: false, originalReplacedVideo: undefined });
    await loadNewSubtitle(
      subtitles,
      subtitles,
      organization.name || "",
      preview,
      0,
      handleUpdateData,
      isTheOriginal
    );
  };

  const syncReplaceVideoSubtitles = async () => {
    const creatomateJson = preview.getSource();
    const video = creatomateJson.elements.find((element: ElementSource) => element.type === VIDEO_TYPE && element.name.startsWith("media-"));
    if (video && video.source === originalReplacedVideo) await recoverSubtitles(creatomateJson);
  };

  const handleUndo = async () => {
    await preview.undo();
    syncSubtitles(handleUpdateData, preview, subtitles);
    await syncReplaceVideoSubtitles();
  };

  return (
    <PlainButton className="Undo-Btn" onClick={handleUndo} disabled={!preview.state?.undo}>
      <Icon className="Undo-Icon" icon="linkedin-share" />
    </PlainButton>
  );
};

export default UndoButton;
